var exports = {
  "R": "xa15a2ab7--4cea67--preloader",
};

module.exports = exports;
